module.exports = __webpack_public_path__ + "img/bhatiac.54e0168d.jpg";